import { UnderlinedButton } from "../../Buttons/UnderlinedButton";
import ArrowRight from "../../../public/images/icons/arrow_right.svg";
import { Spinner } from "../../Spinner/Spinner";

export interface NextButtonProps {
    label: string;
    onNext: () => void;
    loading?: boolean;
    [rest: string]: any;
}
export const NextButton = ({ label, onNext, loading = false, ...rest }: NextButtonProps) => {
    return (
        <UnderlinedButton onClick={onNext} underlineType="secondary" {...rest}>
            <div className="flex flex-row gap-x-1 items-center justify-center">
                <span>{label}</span>
                {loading && <Spinner />}
                {!loading && <ArrowRight className="w-8 h-8 text-white stroke-[3px]" /> }
            </div>
        </UnderlinedButton>
    )
}